/* eslint-disable @next/next/no-img-element */
import classnames from 'classnames';

// styles
import {
  SlideWrapper,
  Title,
  SlidePanel,
  Content,
  Link,
  SystemImage,
} from './Slide.styles';

export function Slide({ property }) {
  return (
    <SlideWrapper
      className={classnames({
        active: property.active,
        inactive: !property.active,
      })}
    >
      <SlidePanel>
        <Title>{property.subtitle}</Title>
        <Content>{property.content}</Content>
        <Link
          href={property.link.url}
          color={property.color}
          target={property.external ? `_blank` : `_self`}
          rel={property.external ? `noreferrer noopener` : ``}
        >
          {property.link.label}
        </Link>
      </SlidePanel>
      {property?.image && (
        <SystemImage>
          <img
            src={`${property.image.src}`}
            alt={property.image.alt}
            width="786"
            height=""
          />
        </SystemImage>
      )}
      {property?.media && <SystemImage>{property.media}</SystemImage>}
    </SlideWrapper>
  );
}
